<template>
  <nav aria-label="breadcrumb" class="breadcrumb-area">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><router-link to="/">HOME</router-link></li>
      <li class="breadcrumb-item active" aria-current="page">フレンドシップファンドのご案内</li>
    </ol>
  </nav>
  <div class="container">
      <div class="top--section">
        <FriendshipFund/>
      </div>
  </div>
</template>
<script setup lang="ts">
import FriendshipFund from '@/components/Static/FriendshipFund.vue'
</script>